import React, { useState } from 'react';
import { Clock, Shield, CreditCard, Mail } from 'lucide-react';
import { LegalModal, PrivacyPolicyContent, TermsOfServiceContent } from './LegalModals';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full bg-teal-500 text-navy-900 py-2 px-4 text-center text-sm font-medium shadow-md" data-id="element-101">
      <div className="flex items-center justify-center gap-2" data-id="element-102">
        <Clock className="w-4 h-4" data-id="element-103" />
        <span data-id="element-104">Launch price $6.39 — Price increases soon</span>
        <a href="#final-cta" className="underline font-bold ml-2 hover:text-navy-800 transition-colors" data-id="element-105">
          Get it now
        </a>
      </div>
    </div>;
}
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-navy-900 border-t border-navy-800 py-12 px-6 text-center text-cream-300/60 text-sm" data-id="element-106">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-107">
        <div className="flex justify-center items-center gap-6 text-cream-300/40" data-id="element-108">
          <div className="flex items-center gap-2" data-id="element-109">
            <Shield className="w-4 h-4" data-id="element-110" />
            <span data-id="element-111">Secure Checkout</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-112">
            <CreditCard className="w-4 h-4" data-id="element-113" />
            <span data-id="element-114">All Cards Accepted</span>
          </div>
        </div>

        <p className="max-w-2xl mx-auto leading-relaxed" data-id="element-115">
          © DiLore Publishing. All Rights Reserved. Results may vary. This
          guide is for educational purposes and does not replace professional
          medical advice. Always consult your physician before beginning any new
          health protocol.
        </p>

        <div className="flex items-center justify-center gap-2" data-id="element-116">
          <Mail className="w-4 h-4" data-id="element-117" />
          <a href="mailto:dilorepublishing@gmail.com" className="hover:text-teal-400 transition-colors" data-id="element-118">
            dilorepublishing@gmail.com
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 pt-4 border-t border-navy-800" data-id="element-119">
          <button onClick={() => setOpenModal('privacy')} className="text-cream-300/60 hover:text-teal-400 transition-colors underline-offset-4 hover:underline" data-id="element-120">
            Privacy Policy
          </button>
          <span className="text-cream-300/30" data-id="element-121">•</span>
          <button onClick={() => setOpenModal('terms')} className="text-cream-300/60 hover:text-teal-400 transition-colors underline-offset-4 hover:underline" data-id="element-122">
            Terms of Service
          </button>
        </div>
      </div>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Privacy Policy" data-id="element-123">
        <PrivacyPolicyContent data-id="element-124" />
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Terms of Service" data-id="element-125">
        <TermsOfServiceContent data-id="element-126" />
      </LegalModal>
    </footer>;
}